import { Link } from "react-router-dom";
import { USE_CASES } from "@/lib/constants";
import { useSeo } from "@/hooks/useSeo";

const USE_CRITERIA = {
  escape_game: { min_surface: 150, min_height: 2.2, erp: true, ventilation: true, criteria: ["Surface > 150 m²", "Hauteur > 2,20 m", "ERP possible", "Ventilation", "Plusieurs zones", "Accès public"] },
  stockage: { min_surface: 20, criteria: ["Sec (pas d'humidité)", "Accès livraison", "Sécurité"] },
  evenementiel: { min_surface: 100, min_height: 2.5, erp: true, criteria: ["Surface > 100 m²", "Hauteur > 2,50 m", "ERP", "Issues de secours", "Accès public"] },
  studio_photo: { min_surface: 40, min_height: 2.8, criteria: ["Hauteur > 2,80 m", "Électricité forte", "Peu de poteaux"] },
  studio_podcast: { min_surface: 15, criteria: ["Isolation acoustique", "Fibre internet", "Silence"] },
  salle_sport: { min_surface: 80, min_height: 2.4, ventilation: true, criteria: ["Ventilation", "Hauteur > 2,40 m", "Vestiaires possibles"] },
  archives: { min_surface: 20, criteria: ["Sec", "Sécurisé", "Accès contrôlé"] },
  dark_kitchen: { min_surface: 40, criteria: ["Extraction", "Arrivée d'eau", "Puissance électrique", "Livraison"] },
  cave_vin: { min_surface: 15, criteria: ["Température stable", "Humidité contrôlée", "Sécurité"] },
  bar_club: { min_surface: 80, min_height: 2.4, erp: true, criteria: ["ERP", "Nuisance sonore autorisée", "Issues de secours"] },
  showroom: { min_surface: 60, criteria: ["Accès public", "Éclairage", "Hauteur"] },
  atelier: { min_surface: 30, criteria: ["Puissance électrique", "Extraction", "Sol résistant"] },
  reserve_commerce: { min_surface: 20, criteria: ["Accès par commerce", "Sec"] },
  data: { min_surface: 15, criteria: ["Climatisation", "Puissance électrique", "Sécurité"] },
  vr: { min_surface: 80, min_height: 2.5, criteria: ["Espace dégagé", "Hauteur", "Ventilation"] },
  autre: { criteria: ["Cas particulier"] },
};

export default function SearchByUse() {
  useSeo({
    title: "Recherche par usage",
    description: "Trouvez un sous-sol adapté à votre projet : escape game, dark kitchen, studio, salle de sport, événementiel, showroom, cave à vin, atelier. Chaque usage a ses critères — nous les appliquons pour vous.",
    path: "/recherche-par-usage",
  });
  return (
    <div className="px-6 md:px-12 lg:px-16 py-16">
      <div className="mb-16 max-w-3xl">
        <div className="label-mono mb-4 text-amber-500">§ recherche par usage</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter mb-6">Je cherche un lieu pour…</h1>
        <p className="text-zinc-400 leading-relaxed">Sélectionnez votre projet. Nous filtrons automatiquement les annonces selon les critères critiques.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
        {USE_CASES.map((u) => {
          const c = USE_CRITERIA[u.value] || { criteria: [] };
          const params = new URLSearchParams({ use_case: u.value });
          if (c.min_surface) params.set("min_surface", c.min_surface);
          if (c.min_height) params.set("min_height", c.min_height);
          if (c.erp) params.set("erp", "true");
          if (c.ventilation) params.set("ventilation", "true");
          return (
            <Link key={u.value} to={`/annonces?${params.toString()}`} data-testid={`search-use-${u.value}`} className="group bg-zinc-950 hover:bg-zinc-900 p-6 transition-colors border-l-2 border-transparent hover:border-amber-500">
              <div className="label-mono mb-3 text-zinc-500 group-hover:text-amber-500">→ {u.value}</div>
              <div className="font-display text-2xl mb-4">{u.label}</div>
              <ul className="space-y-1">
                {c.criteria.map((cr) => <li key={cr} className="text-sm text-zinc-400">· {cr}</li>)}
              </ul>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
